const config = {
    baseURL: window.location.origin,
    apiUrl: window.__RUNTIME_CONFIG__.API_URL,
    client_id: '',
    client_secret: '',
    }
export default config;